import { Vector2 } from 'app/contracts/Geometry';
import HomeColours from 'app/views/home/config/HomeColours';


export class ImagePixelDataGrid {
	constructor(
		private _density: number = 0,
		private _onReady: Function = null,
		private _minSpace: number = 0
	) {}

	private _gridData: Array<Vector2>;
	private _allPixelData: Uint8ClampedArray;
	private _imageWidth: number;
	private _imageHeight: number;
	private _context;
	private _minSpaceCounter: number = 0;

	public get gridData(): Array<Vector2> {
		return this._gridData;
	}

	public getPixelGreyByRatio(xRatio, yRatio, xShift, yShift): number {
		return this.getPixelGreyValue(
			Math.round(this._imageWidth * xRatio),
			Math.round(this._imageHeight * yRatio),
			xShift,
			yShift
		);
	}

	public setDataFromCache(cache) {
		this._allPixelData = cache.allPixelData;
		this._imageWidth = cache.imageWidth;
		this._imageHeight = cache.imageHeight;
	}

	public getPixelGreyValue(x: number, y: number, xShift = 0, yShift = 0): number {
		if (xShift) {
			x = Math.round(x - xShift * this._imageWidth);
		}

		if (yShift) {
			y = Math.round(y - yShift * this._imageHeight);
		}

		const pixelIndex = (x + y * this._imageWidth) * 4;


		const data = this._allPixelData;

		if (!data[pixelIndex]) {
			return;
		}

		const red = data[pixelIndex] / 255;

		const green = data[pixelIndex] / 255;
		const blue = data[pixelIndex] / 255;
		const gray = red * 0.2126 + green * 0.7152 + blue * 0.0722;

		return 1 - Math.max(gray, 0);
	}

	public byURL(url: string, colourSetName: string = null): void {
		const image = new Image();
		image.src = url;
		image.onload = () => {
			this._createCanvas(image);
			this._getAllPixelData(image);
			this._createGrid(image, colourSetName);
		};
	}

	//Private
	//_______________________________________________________________________________________________________

	private _createGrid(image: HTMLImageElement, colourSetName: string = null): void {
		let xSpace: number = Math.floor(image.width * this._density);
		let ySpace: number = Math.floor(image.height * this._density);
		if (xSpace < 1) xSpace = 1;
		if (ySpace < 1) ySpace = 1;
		let y: number = 0;
		let x: number = 0;
		this._minSpaceCounter = 0;

		this._gridData = [];

		while (y <= image.height) {
			x = 0;
			while (x < image.width) {
				const data = this._getPixel(x, y);
				const red = data[0] / 255;
				const green = data[1] / 255;
				const blue = data[2] / 255;

				const isBlack = red < 0.05 && green < 0.05 && blue < 0.05;

				if (this._minSpace) {
					this._minSpaceCounter--;
				}

				if (data[3] !== 0 && !isBlack && this._minSpaceCounter <= 0) {
					const gray = red * 0.2126 + green * 0.7152 + blue * 0.0722;
					Math.max(gray, 0);

					this._gridData.push({
						x: Math.round((x / image.width) * 100000) / 100000,
						y: Math.round((y / image.height) * 100000) / 100000
					});

					if (colourSetName) {
						if (!HomeColours.dynamicSets[colourSetName]) {
							HomeColours.dynamicSets[colourSetName] = [];
						}

						const hex = new PIXI.Color([red, green, blue]).toHex();
						if (!HomeColours.dynamicSets[colourSetName].includes(hex)) {
							HomeColours.dynamicSets[colourSetName].push(hex);
						}
					}

					if (this._minSpace) {
						this._minSpaceCounter = this._minSpace;
					}
				} else if (this._minSpaceCounter <= 0) {
				}

				x += xSpace;
			}

			y += ySpace;
		}
		console.log(JSON.stringify(this._gridData));

		if (this._onReady) {
			this._onReady(this.gridData);
		}

		if (colourSetName) {
		}
	}

	private _createCanvas(img: HTMLImageElement): void {
		const canvas = document.createElement('canvas');
		canvas.width = img.width;
		canvas.height = img.height;
		this._context = canvas.getContext('2d', { willReadFrequently: true });
		this._context.drawImage(img, 0, 0);
	}

	private _getPixel(x: number, y: number): Uint8ClampedArray {
		return this._context.getImageData(x, y, 1, 1).data;
	}

	private _getAllPixelData(img: HTMLImageElement) {
		this._imageWidth = img.width;
		this._imageHeight = img.height;
		this._allPixelData = this._context.getImageData(0, 0, this._imageWidth, this._imageHeight).data;
	}
}
